import { createStore, createEffect, createEvent } from "effector";
import { isFail, unpackServerData } from "../../../common/functions";
import IconDemStatusDone from "../../../common/assets/icons/statusDone.png";
import IconDemStatusAccepted from "../../../common/assets/icons/statusAccepted.png";
import IconDemStatusCanceled from "../../../common/assets/icons/statusCanceled.png";
import IconDemStatusInProgress from "../../../common/assets/icons/statusInProgress.png";
import IconDemStatusNew from "../../../common/assets/icons/statusNew.png";
import IconDemStatusUnknown from "../../../common/assets/icons/statusUnknown.png";
import { IDem, IQueryDem, IQueryDemsResult, IQueryGetFreeDems, IQuerySetDemResult } from "./types";
import axios from "axios"
import { getUuidAndSession } from "../../../common/localStorage";
import { getCustomUserAgent } from "../../../common/customUserAgent";
import { changeSelectedAccountId } from "../../../common/accounts2";

export const $demands = createStore<IQueryDemsResult>({
  loading: true, // до первого ответа считаем, что идёт загрузка (иначе мигает «Заявки не обнаружены!»)
  failMsg: "",
  //freeDemands: [],
  allDems: [],
  //payDemands: [],
});

export const queryDems = createEffect<IQueryDem, IQueryDemsResult>();
export const changeDemsState = createEvent<boolean>()

$demands.on(queryDems.doneData, (_, val) => val);
$demands.on(changeDemsState, (prev, val) => {prev.loading = val; return prev});
// Пока запрос заявок выполняется — держим loading=true, чтобы не показывать
// «Заявки не обнаружены!» / сообщения до завершения всех API.
$demands.on(queryDems.pending, (state, pending) => ({ ...state, loading: pending }));
// При смене ЛС очищаем заявки и показываем загрузчик, пока не придут новые
$demands.reset(changeSelectedAccountId);

queryDems.use((params) =>
  axios.post("https://izba.kras-abs.ru/api/v3/demand/getDemands", {
    ...getUuidAndSession(),
    companyId: params.companyId,
    accountId: params.accountId,
    },{
      headers: {
        "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
        "Custom-User-Agent": getCustomUserAgent(),
      }
    }).then((resp) => {
      let data = unpackServerData(resp.data, "demands")
      //console.log("extarcted_demands:success:", resp)
      return getQueryDemsResObj(data.failMsg, data.data)
    }).catch(e => {
      let msg = e.message
      //console.log("extarcted_demands:error1:", e)
      if(e.response && e.response.data) {
        //console.log("extarcted_demands:error1:", e.response.data)
        let data = unpackServerData(e.response.data)
        if(data.failMsg != "") {
          return getQueryDemsResObj(data.failMsg)
        }
      }
      return getQueryDemsResObj(msg)
    })
);

function getQueryDemsResObj( failMsg: string = "", dems: IDem[] = [] as IDem[] ): IQueryDemsResult {
  let ret = {
    loading: false,
    failMsg: failMsg,
    //freeDemands: [],
    allDems:dems,
    //payDemands: []
  } as IQueryDemsResult;
  /*if(dems.length > 0 ) {
    ret.payDemands = dems.filter((d) => d.isPayable == 1)
    ret.freeDemands = dems.filter((d) => d.isPayable == 0)
  }*/
  return ret
}

export function getDemStatusIconAndColor(statusId: string) {
  statusId += "";
  switch (statusId) {
    case "5":
      return { icon: IconDemStatusDone, color: "#66B429" };
    case "3":
      return { icon: IconDemStatusAccepted, color: "#22549D" };
    case "2":
      return { icon: IconDemStatusNew, color: "#22549D" };
    case "4":
      return { icon: IconDemStatusInProgress, color: "#FF9A5C" };
    case "6":
      return { icon: IconDemStatusCanceled, color: "#949495" };
    default:
      return { icon: IconDemStatusUnknown, color: "#22549D" };
  }
}
/*
////getDems
export interface IQueryGetFreeDemsResult {
  loaded: boolean;
  fail: boolean;
  msg: string;
  dems: IDem[];
}
export interface IQueryGetFreeDems {
  accountId: number;
  companyId: number;
  setLoaded: React.Dispatch<React.SetStateAction<boolean>>;
  setFail: React.Dispatch<React.SetStateAction<boolean>>;
  setFailMsg: React.Dispatch<React.SetStateAction<string>>;
  setDems: React.Dispatch<React.SetStateAction<IDem[]>>;
}*/

export const queryGetFreeDems = ({
  accountId,
  companyId,
  setLoaded,
  setFail,
  setFailMsg,
  setDems,
}: IQueryGetFreeDems) => {
  fetch("https://izba.kras-abs.ru/api/v3/demands/getDemands", {
    method: "POST",
    body: JSON.stringify({
      ...getUuidAndSession(),
      companyId: companyId + "",
      accountId: accountId + "",
    }),
    headers: {
      accept: "*/*",
      "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      "Custom-User-Agent": getCustomUserAgent(),
    },
  })
    .then((res) => res.json())
    .then((res) => {
      let { jsonData, fail, failMsg } = isFail(res, "claim");
      if (!fail) return jsonData;
      throw new Error(failMsg);
    })
    .then((res) => {
      setLoaded(true);
      setFail(false);
      setDems(res.claim as IDem[]);
    })
    .catch((err) => {
      setLoaded(true);
      setFail(true);
      setFailMsg(err.message);
    });
};
/*
///////////////////////////////////////////////////////////////////
export interface IQuerySetDem {
  formData: FormData;
}

export interface IQuerySetDemResult {
  loaded: boolean;
  fail: boolean;
  msg: string;
  dem: IDem;
}*/

export const querySetDem = (
  formData: FormData,
  setDemRateRes: React.Dispatch<React.SetStateAction<IQuerySetDemResult>>
) => {
  let uuidSession = getUuidAndSession()
  //@ts-ignore
  formData.append("uuid", uuidSession.uuid);
  //@ts-ignore
  formData.append("session", uuidSession.session);
  fetch("https://izba.kras-abs.ru/api/v3/demand/setFreeDemand", {
    method: "POST",
    body: formData,
  })
    .then((res) => res.json())
    .then((res) => {
      let { jsonData, fail, failMsg } = isFail(res);
      if (!fail) return jsonData;
      throw new Error(failMsg);
    })
    .then((res) => {
      const ret = {
        loaded: true,
        fail: false,
        msg: JSON.stringify(res),
        dem: res.setDemand,
      } as IQuerySetDemResult;
      setDemRateRes(ret);
    })
    .catch((err) => {
      const ret = {
        loaded: true,
        fail: true,
        msg: err.message,
      } as IQuerySetDemResult;
      setDemRateRes(ret);
    });
};
